import { styled } from "@mui/material/styles";
import { Box, Avatar, Tab as BaseTab } from "@mui/material";

const HeaderContainer = styled(Box)(({ theme }) => ({
  zIndex: 200,
  display: "flex",
  justifyContent: "end",
  alignItems: "center",
  backgroundColor: "#294257CC",
  backdropFilter: "blur(5px)",
  transform: "translateZ(0)",
  willChange: "transform",
  borderBottom: "2px solid black",
  borderTop: "2px solid black",
  padding: "15px 40px 15px 30px",
  height: 89,
  width: "100%",

  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(1, 2),
    height: "unset",
  },
}));

const HeaderAvatarBox = styled(Box)(({ theme }) => ({
  display: "flex",
  backgroundColor: "#203344",
  borderRadius: 60,
  width: "fit-content",
  height: "fit-content",
  border: "solid 2px black",
  transition: "padding .3s ease-in-out",

  position: "absolute",
  left: 30,
  zIndex: 1,

  "&:hover": {
    padding: theme.spacing(0.5),
    cursor: "pointer",
  },

  [theme.breakpoints.down("lg")]: {
    left: 15,
  },
}));

const HeaderAvatarImg = styled(Avatar)(({ theme }) => ({
  height: 45,
  width: 45,

  [theme.breakpoints.down("md")]: {
    height: 35,
    width: 35,
  },
}));

const HeaderTitleTextWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginLeft: theme.spacing(2),
  marginRight: theme.spacing(1),

  [theme.breakpoints.down("md")]: {
    margin: theme.spacing(0, 1),
  },
}));

const HeaderTitleText = styled(Box)(({ theme }) => ({
  fontFamily: "Source Code Pro",
  color: "white",
  fontSize: 20,
  whiteSpace: "pre",
  lineHeight: 1.1,

  [theme.breakpoints.down("md")]: {
    fontSize: 14,
    lineHeight: 1.2,
  },
}));

const menuSx = (theme) => ({
  "& .MuiPaper-root": {
    position: "relative",
    width: "min-content",
    backgroundColor: "unset",
    backgroundImage: "unset",
    border: `1px solid ${theme.palette.primary.veryDark}`,
    backdropFilter: "blur(5px)",

    "&:before": {
      content: "''",
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: theme.palette.primary.dark,
      opacity: 0.85,
    },
  },
});

const Tab = styled(BaseTab)(({ theme }) => ({
  color: "#aec2d4",
  textShadow: "2px 2px 2px black",
  fontFamily: "Source Sans Pro",
  fontSize: 25,
  borderRadius: "10px",
  transition: theme.transitions.create(["color", "background-color"], {
    duration: 250,
  }),

  "&:hover": {
    backgroundColor: "#1c2d3bb2",
    color: "white",
  },

  "&.Mui-selected": {
    color: "white",
  },

  "& > *": {
    borderRadius: "10px",
  },

  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(0, 0),
    width: 75,
    minWidth: 75,
  },
}));

export {
  HeaderContainer,
  HeaderAvatarBox,
  HeaderAvatarImg,
  HeaderTitleTextWrapper,
  HeaderTitleText,
  menuSx,
  Tab,
};
